import { render, staticRenderFns } from "./WxSimpleCalendarDatePicker.vue?vue&type=template&id=2cbc2fe3&scoped=true"
import script from "./WxSimpleCalendarDatePicker.vue?vue&type=script&lang=js"
export * from "./WxSimpleCalendarDatePicker.vue?vue&type=script&lang=js"
import style0 from "./WxSimpleCalendarDatePicker.vue?vue&type=style&index=0&id=2cbc2fe3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbc2fe3",
  null
  
)

export default component.exports